import * as React from 'react';
import {
  EditorActionsManager,
  UpdateCustomAttributeAction,
  VirtualChildComponent,
} from '@easytwin/runtime';
import { isNil } from '@/utils';
import { ProInput } from '@/UIGenerator';
import { ImmerFormItem } from '@/UIGenerator/uicomponents/ImmerFormItem';

interface CustomAttributesValueFormProps {
  attribute: Record<string, any>;
  comp: VirtualChildComponent;
}
export default function CustomAttributeValueForm({
  attribute,
  comp,
}: CustomAttributesValueFormProps) {
  const onAttributeValueChange = (name: string, value: unknown) => {
    if (isNil(comp)) {
      return;
    }
    comp.updateCustomAttribute(name, value, false);
  };

  const onAttributeValueConfirm = (name: string, value: unknown) => {
    if (isNil(comp)) {
      return;
    }

    const editorActionManager = comp.engine.getManager(EditorActionsManager);
    editorActionManager.execute(new UpdateCustomAttributeAction(comp, name, value));
  };

  const formContent = (
    <div>
      {attribute
        ? Object.keys(attribute).map((key) => {
            return (
              <ImmerFormItem key={key} label={key}>
                <ProInput
                  autoComplete='off'
                  maxLength={Infinity}
                  className='w-full'
                  name={key}
                  value={attribute[key]}
                  onChange={onAttributeValueChange}
                  onBlur={onAttributeValueConfirm}
                />
              </ImmerFormItem>
            );
          })
        : null}
    </div>
  );

  return (
    <div>
      <div>{formContent}</div>
    </div>
  );
}
